









import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME as ConstName } from '../constants';
import { apiProvider } from '../api';

type DataType = {
	TASK_ID: string;
	ORDER_NUMBER: string;
	CREATION_DATE: string;
};

export default BaseSelect.extend({
	name: selectName(ConstName),
	props: {
		labelKey: { type: String, default: 'TASK_ID' },
		isClearable: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: ConstName,
			valueFieldName: 'TASK_ID',
			apiProvider,
			emptyObject: {
				isClear: true,
				value: null,
				text: null,
				Name: null,
				TaskId: null,
				OrderNumber: null,
				CreationDate: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: DataType) {
			return {
				value: data.TASK_ID,
				text: data.ORDER_NUMBER,
				Name: data.ORDER_NUMBER,
				TaskId: data.TASK_ID,
				OrderNumber: data.ORDER_NUMBER,
				CreationDate: data.CREATION_DATE,
			};
		},

		async openGrid() {
			this.setPageManagerMapper();
		},
	},
});
